// extracted by mini-css-extract-plugin
export default {"interactiveElementHTML":"useCursorPointerWithTheme_interactiveElementHTML__rB5Lh","interactiveElementHTMLDark":"useCursorPointerWithTheme_interactiveElementHTMLDark__oqbP9"};